import { render, staticRenderFns } from "./SearchingCarsPage.vue?vue&type=template&id=3d45f648&scoped=true&"
import script from "./SearchingCarsPage.vue?vue&type=script&lang=js&"
export * from "./SearchingCarsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d45f648",
  null
  
)

export default component.exports